import { render, staticRenderFns } from "./JgpTools.vue?vue&type=template&id=50dcdf32&"
import script from "./JgpTools.vue?vue&type=script&lang=js&"
export * from "./JgpTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports